

$(document).ready(function() {

    $('.nav-level-1 .nav-item .more').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).toggleClass("submenu-opened");
        $(this).parent().find('> ul').slideToggle('fast');
    });

});